require('./cardBilling.scss');

const PropTypes = require('prop-types');

// @core
const React = require('react');
// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
// @components
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE
} = require('constants/index');
const { PAY_LATER } = require('constants/flagBasedFeatures');

const CardBilling = props => {
    const { immCard, cardId, immCardChangePaymentMethod, immPayLaterInfo, isCardCancelPayLaterEnabled, flagBasedFeatures } = props;
    let cardBillingLink;
    let cardSettlementsContent;
    let payLaterContent;
    let cardPayLaterOption;

    if ( immCardChangePaymentMethod.get('isFetching') ){
        return <LoadingSection />;
    }

    const currentPaymentMethod = immCardChangePaymentMethod.getIn(['steps', '0', 'currentPaymentMethod']);
    const methodDescription = immCardChangePaymentMethod.getIn(['steps', '0', 'methodDescription']).split(' ');
    const amount = [];
    let paymentMethod;

    switch (currentPaymentMethod) {
        case CARD_PAYMENT_METHOD_UNIQUE:
            amount.push(methodDescription[3]);
            paymentMethod = `${formatText('contractsView-cardPaymentMethodUnique')} ${amount[0]}%`;
            break;
        case CARD_PAYMENT_METHOD_FIXED:
            amount.push(`${methodDescription[2]} ${methodDescription[3]}`);
            paymentMethod = `${formatText('contractsView-cardPaymentMethodFixed')} ${amount[0]}`;
            break;
        case CARD_PAYMENT_METHOD_VARIABLE:
            amount.push(methodDescription[4], `${methodDescription[7]} ${methodDescription[8]}`);
            paymentMethod = `${formatText('contractsView-cardPaymentMethodVariable', [amount[0], amount[1]])}`;
            break;
    }

    if (cardValidationRules.CARD_CHANGE_PAYMENT_METHOD.validator({immCard, immFlagBasedFeatures: flagBasedFeatures})) {
        cardBillingLink = (
            <div>
                <OKLink modifier="emphasize" to={`/myprofile/cards/${cardId}/payment-method/change`}>
                    <FormattedText
                        value="cardDetails-change"
                    />
                </OKLink>
            </div>
        );
    }

    if (cardValidationRules.CARD_STATEMENT_MOVEMENTS.validator({immCard})) {
        cardSettlementsContent = (
            <OKInformativeListItem title="cardDetails-settlements">
                <OKLink modifier="emphasize" to={`/myprofile/cards/${cardId}/statements`}>
                    <FormattedText
                        value="cardDetails-statements"
                    />
                </OKLink>
            </OKInformativeListItem>
        )
    }

    if (cardValidationRules.CARD_PAY_LATER.validator({immCard})){
        if(immPayLaterInfo && immPayLaterInfo.get('payLaterOpted')){
            const date = immPayLaterInfo.get('payLaterOptedDate', '');
            let cancelPayLaterButton;
            if(isCardCancelPayLaterEnabled){
                cancelPayLaterButton = (<div>
                    <OKLink
                        modifier="emphasize"
                        to={`/myprofile/cards/${cardId}/cancel-pay-later`}
                    >
                        <FormattedText value="cardDetails-cardDetails_cancelButtonText" />
                    </OKLink>
                </div>)
            }
            payLaterContent = (
                <React.Fragment>
                    <FormattedText
                        value="cardDetails-payLaterOptedMessage"
                        injectedStrings={[date]}
                    />
                    {cancelPayLaterButton}
                </React.Fragment>
            )
            cardPayLaterOption = (
                <OKInformativeListItem title="cardDetails-payLater" bodyText={payLaterContent}>
                </OKInformativeListItem>
            )

        } else if (flagBasedFeatures.get(PAY_LATER)) {
            cardPayLaterOption = (
                <OKInformativeListItem title="cardDetails-payLater">
                    <OKLink modifier="emphasize" to={`/myprofile/cards/${cardId}/pay-later`}>
                        <FormattedText
                            value="cardDetails-payLaterLink"
                        />
                    </OKLink>
                </OKInformativeListItem>
            )
        }
    }

    return (
        <OKInformativeList title="cardDetails-billing" columns={2}>
            <OKInformativeListItem title="cardDetails-chargeAccount" bodyText={immCard.get('associatedAccount')} />
            <OKInformativeListItem title="cardDetails-paymentMethod" className="card-billing__payment">
                <div className="card-billing__value">
                    {paymentMethod}
                </div>
                {cardBillingLink}
            </OKInformativeListItem>
            {cardSettlementsContent}
            {cardPayLaterOption}
        </OKInformativeList>
    );
};

CardBilling.propTypes = {
    cardId: PropTypes.string.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardChangePaymentMethod: PropTypes.object.isRequired,
    immPayLaterInfo: PropTypes.object.isRequired,
    isCardCancelPayLaterEnabled: PropTypes.bool.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = CardBilling;
